<div class="map-container">
  <div id="map-host"></div>
</div>
